import ShareModalMultiple from "../Gallery/ShareModalMultiple/ShareModalMultiple";
import useOnboardingChecklist from "../../hooks/useOnboardingChecklist";

const OnboardingChecklistShareModal = () => {
  const { isShareModalOpen, onCloseShareModal } = useOnboardingChecklist();

  if (!isShareModalOpen) {
    return null;
  }

  return (
    <ShareModalMultiple
      modalOpen={isShareModalOpen}
      onCloseModal={onCloseShareModal}
      item={null}
    />
  );
};

export default OnboardingChecklistShareModal;
